import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
  btnNewArticle: {
    float: 'right',
    padding: theme.spacing(1, 2),
  },
  containerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  formGroup: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  }
}));